import { createContext, useContext } from 'react';
import {
  I18n,
} from '../utils/i18n';

export const I18nContext = createContext(new I18n());

export const useI18nContext = () => useContext(I18nContext);
